import { TabHeader } from '@containers/Headers/TabHeader'
import { ScreenContainer } from '@containers/ScreenContainer'

import { FiltersLoader } from './Loader'

export function FiltersView() {
  return (
    <ScreenContainer header={<TabHeader />}>
      <FiltersLoader />
    </ScreenContainer>
  )
}
